module.exports = {
  title: '角色设置',
  route: {
    path: '/admin-power-manage',
    children: {
      path: 'power-role-form',
    },
  },
};
